import { render, staticRenderFns } from "./JobStatus.vue?vue&type=template&id=6835bea1&scoped=true&"
import script from "./JobStatus.vue?vue&type=script&lang=js&"
export * from "./JobStatus.vue?vue&type=script&lang=js&"
import style0 from "./JobStatus.vue?vue&type=style&index=0&id=6835bea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835bea1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6835bea1')) {
      api.createRecord('6835bea1', component.options)
    } else {
      api.reload('6835bea1', component.options)
    }
    module.hot.accept("./JobStatus.vue?vue&type=template&id=6835bea1&scoped=true&", function () {
      api.rerender('6835bea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/components/JobStatus.vue"
export default component.exports